import { type LoadPreviousSessionResponse, type SendMessageResponse, type ChatApiOptions } from '@chatbot/typings/types';
import { post, postWithFiles } from './generic';
import { API_ACTION_LOAD_SESSION, API_ACTION_SEND_MESSAGE, CHAT_SESSION_KEY, CHAT_INPUT_KEY } from '@chatbot/constants/chat';

export const loadPreviousSession = async(sessionId: string,
    options: ChatApiOptions): Promise<LoadPreviousSessionResponse> => {
    // Always use POST for loading previous session
    const { webhookUrl } = options;

    if (!webhookUrl) {
        throw new Error('Webhook URL is required');
    }

    return post<LoadPreviousSessionResponse>(webhookUrl,
        {
            action: API_ACTION_LOAD_SESSION,
            [CHAT_SESSION_KEY]: sessionId,
            ...(options.metadata ? { metadata: options.metadata } : {}),
        });
};

const createPayload = (
    sessionId: string, message: string, metadata?: Record<string, unknown>,
): Record<string, string | object> => ({
    action: API_ACTION_SEND_MESSAGE,
    [CHAT_SESSION_KEY]: sessionId,
    [CHAT_INPUT_KEY]: message,
    ...(metadata ? { metadata } : {}),
});

export const sendMessage = async(
    message: string,
    files: File[],
    sessionId: string,
    options: ChatApiOptions,
): Promise<SendMessageResponse> => {
    const { webhookUrl } = options;

    if (!webhookUrl) {
        throw new Error('Webhook URL is required');
    }

    const payload = createPayload(
        sessionId, message, options.metadata,
    );

    if (files.length > 0) {
        return postWithFiles<SendMessageResponse>(
            webhookUrl, payload, files,
        );
    }

    return post<SendMessageResponse>(webhookUrl, payload);
};
